import noop from 'lodash/noop';
import { EventTracker } from '../events';
import { createSiftClient, createSiftNoopClient, SiftClient } from '../clients';

type TrackerArgs = {
  beaconKey: string;
  enabled: boolean;
};

export const createSiftTracker = (options: TrackerArgs): EventTracker => {
  let client: SiftClient;

  if (options.enabled) {
    client = createSiftClient(options.beaconKey);
  } else {
    client = createSiftNoopClient();
  }

  return {
    onContextChange: (_updates, newContext, oldContext) => {
      if (newContext.activePath?.concrete !== oldContext.activePath?.concrete) {
        client.trackPageView();
      }

      if (newContext.activeUser?.id !== oldContext.activeUser?.id && newContext.activeUser?.id) {
        client.setUserId(newContext.activeUser.id);
      }
    },

    accountLogin: noop,
    addedProductToCart: noop,
    buyItAgainImpression: noop,
    buyItAgainViewAllClicked: noop,
    checkoutStarted: noop,
    dutchiePayEnrollmentButtonClicked: noop,
    dutchiePayCTAButtonClicked: noop,
    dutchiePayEnrollmentStep: noop,
    dutchiePayEnrollmentStepCancelled: noop,
    dutchiePayPlaidOnEvent: noop,
    dutchiePayPlaidOnLoad: noop,
    dutchiePayPlaidOnSuccess: noop,
    dutchiePayPlaidOnExit: noop,
    dutchiePayAeroSyncOnEvent: noop,
    dutchiePayAeroSyncOnLoad: noop,
    dutchiePayAeroSyncOnClose: noop,
    dutchiePayAeroSyncOnSuccess: noop,
    dutchiePayAeroSyncOnError: noop,
    dutchiePayPreAuthEvent: noop,
    dutchiePayInstoreAccountLinkViewed: noop,
    dutchiePayInstoreCartApprovalClicked: noop,
    dutchiePayInstoreCartApprovalFailed: noop,
    dutchiePayInstoreCartApprovalSucceeded: noop,
    dutchiePayInstoreCartViewed: noop,
    dutchiePayInstoreLoginViewed: noop,
    dutchiePayRelinkButtonViewed: noop,
    dutchiePayRelinkButtonClicked: noop,
    dutchiePayUnlinkRemoveCtaClicked: noop,
    dutchiePayUnlinkModalViewed: noop,
    dutchiePayUnlinkConfirmed: noop,
    dutchiePayUnlinkCancelled: noop,
    dutchiePayUnlinkSuccess: noop,
    dutchiePayUnlinkError: noop,
    loyaltySignup: noop,
    paymentsError: noop,
    placedOrder: noop,
    productClicked: noop,
    privacyPreferenceUpdated: noop,
    removedProductFromCart: noop,
    searchedForProduct: noop,
    searchResults: noop,
    viewedCheckout: noop,
    checkoutSession: noop,
    viewedProduct: noop,
    cartUpdated: noop,
    cartViewed: noop,
    imageBannerClicked: noop,
    sponsoredProductImpression: noop,
    sponsoredProductClicked: noop,
    sponsoredBannerImpression: noop,
    sponsoredBannerClicked: noop,
    gaGTMClickEvent: noop,
    dispensaryClicked: noop,
    dutchiePayKioskQRCodeModalViewed: noop,
    viewedKioskCheckoutModal: noop,
    loginNudge: noop,
    roundupForCharityViewed: noop,
    roundupForCharityToggled: noop,
    walletPass: noop,
    dutchiePayLinkToPayInitiated: noop,
    dutchiePayLinkToPayIneligible: noop,
    dutchiePayEcommModalPaymentSwitchViewed: noop,
    dutchiePayEcommModalPaymentSwitchClicked: noop,
    dutchiePayEcommModalPaymentSwitchOutcome: noop,
    dutchiePayLoyaltyCtaClicked: noop,
    instoreEnrollmentStepViewed: noop,
    instoreEnrollmentStepCompleted: noop,
    instoreEnrollmentStepSkipped: noop,
    medCardSignupCompleted: noop,
    medCardSignupFailed: noop,
  };
};
